import { createContext, useContext, useState } from 'react';

const AppContext = createContext();
const useApp = () => {
  return useContext(AppContext);
};

const AppProvider = ({ children }) => {
  const [centersId, setCentersId] = useState('');

  return (
    <AppContext.Provider
      value={{
        centersId,
        setCentersId,
      }}>
      {children}
    </AppContext.Provider>
  );
};

export { useApp, AppProvider };
